import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { CreateDeliveryDevice } from 'app/dtos/deliveryDevice/CreateDeliveryDevice';
import { UpdateDeliveryDevice } from 'app/dtos/deliveryDevice/updateDeliveryDevice';

@Injectable({
  providedIn: 'root'
})
export class DeliveryDeviceService {

  constructor(private httpClientService: HttpClientService) { }

  async getDeliveryByIdDevices(page, size, id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action: "GetDeliveryByIdDevices",
      queryString: `Page=${page}&Size=${size}`
    }, id);
    return await firstValueFrom(observable);
  }

  async getByIdDeliveryDevice(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice
    }, id);
    return await firstValueFrom(observable);
  }

  async getByIdDeliveryDeviceCalibration(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action:"GetByIdDeliveryDeviceCalibration"
    }, id);
    return await firstValueFrom(observable);
  }

  async createDeliveryDevice(createDeliveryDevice: CreateDeliveryDevice) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.DeliveryDevice
    }, createDeliveryDevice);
    return await firstValueFrom(observable);
  }

  async updateDeliveryDevice(updateDeliveryDevice: UpdateDeliveryDevice) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.DeliveryDevice
    }, updateDeliveryDevice);
    return await firstValueFrom(observable);
  }

  async getAllNotCalibrationDevices(page, size, search,kindId,companyId,certificateCompanyId,startDate,endDate) {
    const queryParams = new URLSearchParams();

    queryParams.append("Page", page.toString());
    queryParams.append("Size", size.toString());
    queryParams.append("search", search.toString());

    if (startDate !== null && startDate !== undefined) queryParams.append("StartDate", startDate);
    if (endDate !== null && endDate !== undefined) queryParams.append("EndDate", endDate);
    if (companyId !== null && companyId !== undefined) queryParams.append("CompanyId", companyId.toString());
    if (kindId !== null && kindId !== undefined) queryParams.append("kindId", kindId.toString());
    if (certificateCompanyId !== null && certificateCompanyId !== undefined) queryParams.append("certificateCompanyId", certificateCompanyId.toString());

    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryDevice,
      action: "GetAllNotCalibrationDevices",
      queryString: queryParams.toString()
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
